export default __webpack_public_path__ + "static/media/mushroom-error_EN.1b63d05f.png";